/* Black Weeks 2026 — Countdown, Scheinwerfer, Scroll-Einblendung, Kategorie-Vorschau. */
(function () {
  if (window.__bf2026) return;
  window.__bf2026 = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdowns() {
    document.querySelectorAll('[data-bf-count]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-bf-count')).getTime();
      if (isNaN(end)) return;
      var f = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function tick() {
        var t = Math.max(0, end - Date.now());
        f.d.textContent = pad(Math.floor(t / 864e5));
        f.h.textContent = pad(Math.floor(t / 36e5) % 24);
        f.m.textContent = pad(Math.floor(t / 6e4) % 60);
        f.s.textContent = pad(Math.floor(t / 1e3) % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initSpotlight() {
    document.querySelectorAll('[data-bf-stage]').forEach(function (stage) {
      var hero = stage.closest('.bf-hero') || stage;
      var tx = 55, ty = 45, x = tx, y = ty, auto = true, t0 = performance.now();
      hero.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = stage.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width) * 100;
        ty = ((e.clientY - r.top) / r.height) * 100;
        auto = false;
      });
      hero.addEventListener('pointerleave', function () { auto = true; });
      function frame(now) {
        if (auto) {
          var k = (now - t0) / 1000;
          tx = 52 + Math.sin(k * 0.55) * 22;
          ty = 48 + Math.sin(k * 0.9) * 12;
        }
        x += (tx - x) * 0.08;
        y += (ty - y) * 0.08;
        stage.style.setProperty('--mx', x.toFixed(2) + '%');
        stage.style.setProperty('--my', y.toFixed(2) + '%');
        requestAnimationFrame(frame);
      }
      if (reduced) {
        stage.style.setProperty('--r', '2000px');
      } else {
        requestAnimationFrame(frame);
      }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.bf-reveal');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initPeek() {
    document.querySelectorAll('[data-bf-index]').forEach(function (list) {
      var peek = list.querySelector('.bf-index__peek');
      var img = peek && peek.querySelector('img');
      if (!peek || !img) return;
      list.querySelectorAll('.bf-index__row').forEach(function (row) {
        row.addEventListener('pointerenter', function () {
          var src = row.getAttribute('data-img');
          if (!src) return;
          img.src = src;
          peek.classList.add('is-on');
        });
        row.addEventListener('pointerleave', function () { peek.classList.remove('is-on'); });
      });
      window.addEventListener('scroll', function () { peek.classList.remove('is-on'); }, { passive: true });
      list.addEventListener('pointermove', function (e) {
        peek.style.left = e.clientX + 'px';
        peek.style.top = e.clientY + 'px';
      });
    });
  }

  function init() { initCountdowns(); initSpotlight(); initReveal(); initPeek(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__bf2026 = false; });
})();
